export default __webpack_public_path__ + "fadd9af0d7f843ee2b4507f311bb2904.png";